export let sundayUppercase = "ACTw_c";
export default {sundayUppercase};